export const ENTRA_TYPE_MAP = {
  0: 'entraUsers',
  1: 'entraGroups',
  2: 'entraRoles',
  3: 'entraAdminUnits',
  4: 'entraAppRegistrations',
  5: 'entraEnterpriseApplications',
  6: 'entraDevices',
  7: 'entraDeviceConfiguration',
  8: 'entraDeviceCompliancePolicy',
  9: 'entraDeviceBitlockerRecoveryKeys',
  10: 'entraPolicies',
  11: 'entraSignInLog',
  12: 'entraAuditLog',
};
